var e=process.env.NODE_ENV==="development"||process.env.NODE_ENV==="test",s=e;export{s as default};
//# sourceMappingURL=isDev.js.map
